import { useContext } from 'react'
import { AuthContext } from './AuthContext'

/**
 * Hook to get auth context (logout). Throws if used outside OktaAuthProvider or LegacyAuthProvider.
 */
export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) {
    throw new Error('useAuth must be used within OktaAuthProvider or LegacyAuthProvider')
  }
  return ctx
}

/**
 * Hook to get auth context (logout) or null if outside providers (e.g. on login page).
 */
export function useAuthOptional() {
  return useContext(AuthContext)
}
